if (!customElements.get('check-inventory')) {
  class CheckInventory extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback () {
      this._cache = new Map();
      this._currentVariant = { sku: this.getAttribute('data-variant-sku') || '' };
      this._setupEventListeners();
      this._triggerInventoryCheck();
    }

    _setupEventListeners () {
      document.addEventListener('on:variant:change', (e) => {
        this._currentVariant = e.detail.variant;
        this._triggerInventoryCheck();
      });

      document.addEventListener('on:variant-options:change', () => {
        this._triggerInventoryCheck();
      });

      if (!window._inventoryHistoryBound) {
        const bindHistoryEvent = (type) => {
          const original = history[type];
          history[type] = function (...args) {
            original.apply(this, args);
            window.dispatchEvent(new Event(type));
          };
        };
        bindHistoryEvent('pushState');
        bindHistoryEvent('replaceState');
        window._inventoryHistoryBound = true;
      }
      window.addEventListener('popstate', () => this._triggerInventoryCheck());
      window.addEventListener('replaceState', () => this._triggerInventoryCheck());
      window.addEventListener('pushState', () => this._triggerInventoryCheck());

      document.querySelector('.qty-input')?.addEventListener('click', (e) => {
        if (e.target.closest('button')) this._triggerInventoryCheck();
      });
      document.querySelector('input[name="quantity"]')?.addEventListener('change', () => this._triggerInventoryCheck());
    }

    async _triggerInventoryCheck () {
      const sku = String(this._currentVariant?.sku || this.getAttribute('data-variant-sku') || '').trim();
      if (!sku) return;

      const quantity = document.querySelector('input[name="quantity"]')?.value || 1;
      const variantOptionsInputs = document.querySelectorAll('input[id^="product_variant_options_"][type="hidden"]');
      const propertiesValue = Array.from(variantOptionsInputs)
        .map(input => `${input.id.replace('product_variant_options_', '')}:${input.value}`)
        .join(';');

      const cacheKey = `${sku}-${quantity}-${propertiesValue}`;

      if (this._cache.has(cacheKey)) {
        const hasInventory = this._cache.get(cacheKey);
        this.style.display = hasInventory ? 'flex' : 'none';
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append('sku', sku);
        params.append('quantity', quantity);
        params.append('properties', propertiesValue);

        const response = await fetch('https://lampwmsapi.gearun.com/api/Check/CheckOverseasInventoryBySKU', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString(),
        });

        const data = await response.json();
        this._cache.set(cacheKey, data.HasInventory);
        this.style.display = data.HasInventory ? 'flex' : 'none';
      } catch (error) {
        console.error('[Inventory Check] Error:', error);
      }
    }

    setVariantSku (sku) {
      this._currentVariant = { sku };
      this._triggerInventoryCheck();
    }
  }

  customElements.define('check-inventory', CheckInventory);
}